export class Blustream {
    constructor(socket, log) {
        this.socket = socket;
        this.log = log;
        this.asyncHandlers = [
            {
                name: 'status',
                regExp: /STATUS/i,
                callback: (match) => {
                    this.socket.send(this.product.createStatusMessage(this.product));
                },
            },
            {
                name: 'power',
                regExp: /(PON|POFF)/i,
                callback: (match) => {
                    this.product.status.power = match[1] === 'PON';
                    this.socket.send(`${this.product.status.power ? 'PON' : 'POFF'}\r\n[SUCCESS]Set system power ${this.product.status.power ? 'ON, please wait a moment...' : 'OFF.'}`);
                },
            },
            {
                name: 'matrixRoute',
                regExp: /OUT(\d+)FR(.+)/i,
                callback: (match) => {
                    const outputIndex = parseInt(match[1], 10) - 1;
                    let inputNameReturned;
                    if (this.product.model === 'MFP62') {
                        // The MFP62 syntax requires the input be an of the form '01' so we translate to a name
                        // for command ack and matrix setting status.
                        const inputSelected = this.product.inputs.find(p => p.port === match[2]);
                        if (inputSelected) {
                            this.product.outputs[outputIndex].input = inputSelected.name;
                            inputNameReturned = inputSelected.port;
                            this.socket.send(`[SUCCESS]Set all output connect from input ${inputNameReturned}`);
                        }
                    }
                    else if (this.product.model === 'C44-Kit') {
                        // C44 status messages and status show rounting using the ports not names
                        this.product.outputs[outputIndex].input = match[2];
                        this.socket.send(`[SUCCESS]Set output ${match[1]} connect from input ${match[2]}`);
                    }
                    else {
                        // The MFP72 and MFP112 use the input names for referring to inputs.
                        if (this.product.inputs.find(p => p.name === match[2])) {
                            // store the name of the input as the routed input to the output with the output
                            this.product.outputs[outputIndex].input = match[2];
                            // The MFP72 reports HDMI2 as HDMI 02 in command acknowlegment message
                            inputNameReturned = this.adjustInputName(match[2]);
                            this.socket.send(`[SUCCESS]Set output ${match[1]} connect from input ${inputNameReturned}.`);
                        }
                        else {
                            this.socket.send(`[ERROR]Invalid input`);
                        }
                    }
                },
            },
            {
                name: 'volume',
                regExp: /VOL\s+(\d+)/i,
                callback: (match) => {
                    this.product.volume = parseInt(match[1], 10);
                    this.socket.send(`[SUCCESS]Set all output volume to ${this.product.volume.toString()}.`);
                },
            },
            {
                name: 'volumeMute',
                regExp: /MUTE(ON|OFF)/i,
                callback: (match) => {
                    this.product.mute = match[1].toUpperCase() === 'ON';
                    this.socket.send(`[SUCCESS]Set all output audio mute ${this.product.mute ? 'ON' : 'OFF'}.`);
                },
            },
            {
                name: 'invalid',
                regExp: /.+/i,
                callback: (match) => {
                    this.socket.send(`[ERROR]Command not found.`);
                },
            },
        ];
        this.products = [
            {
                createStatusMessage: this.c44KitCreateStatusMessage,
                modelNumber: '-MRUxQCH-6GynWFmfoaL',
                model: 'C44-Kit',
                name: 'HDMI/DHBT Matrix-4x4 Status',
                version: '1.03',
                status: {
                    power: false,
                    ir: false,
                    key: false,
                    apm: false,
                    beep: false,
                    lcd: false,
                },
                inputs: [
                    {
                        port: '01',
                        name: 'HDMI1',
                    },
                    {
                        port: '02',
                        name: 'HDMI2',
                    },
                    {
                        port: '03',
                        name: 'HDMI3',
                    },
                    {
                        port: '04',
                        name: 'HDMI4',
                    },
                ],
                outputs: [
                    {
                        input: '01',
                        port: '01',
                        name: 'HDBaseT 1',
                        outputEnabled: true,
                        hdmiCon: true,
                        osp: 'SNK',
                    },
                    {
                        input: '01',
                        port: '02',
                        name: 'HDBaseT 2',
                        outputEnabled: true,
                        hdmiCon: true,
                        osp: 'SNK',
                    },
                    {
                        input: '01',
                        port: '03',
                        name: 'HDBaseT 3',
                        outputEnabled: true,
                        hdmiCon: true,
                        osp: 'SNK',
                    },
                    {
                        input: '01',
                        port: '04',
                        name: 'HDBaseT 4',
                        outputEnabled: true,
                        hdmiCon: true,
                        osp: 'SNK',
                    },
                ],
            },
            {
                createStatusMessage: this.mfp62CreateStatusMessage,
                modelNumber: '-M5g_w8h5S1qi0ymg0T5',
                volume: 75,
                mute: false,
                model: 'MFP62',
                name: 'HDMI MFP62 Status',
                version: '1.24',
                status: {
                    power: false,
                    ir: false,
                    key: false,
                    apm: false,
                    beep: false,
                    lcd: false,
                },
                inputs: [
                    {
                        port: '01',
                        name: 'HDMI1',
                    },
                    {
                        port: '02',
                        name: 'HDMI2',
                    },
                    {
                        port: '03',
                        name: 'HDMI3',
                    },
                    {
                        port: '04',
                        name: 'DP',
                    },
                    {
                        port: '05',
                        name: 'USB-C',
                    },
                    {
                        port: '06',
                        name: 'VGA',
                    },
                ],
                outputs: [
                    {
                        input: 'HDMI1',
                        port: '01',
                        name: 'HDMI1',
                        outputEnabled: true,
                        hdmiCon: true,
                        osp: 'SNK',
                    },
                    {
                        input: 'HDMI1',
                        port: '02',
                        name: 'HDMI1',
                        outputEnabled: true,
                        hdmiCon: true,
                        osp: 'SNK',
                    },
                ],
            },
            {
                createStatusMessage: this.mfp72CreateStatusMessage,
                modelNumber: '-M5g_t8MFcK8_22gnqqY',
                volume: 15,
                mute: false,
                model: 'MFP72',
                name: 'HDMI MFP72  Status',
                version: '2.11',
                status: {
                    power: false,
                    ir: false,
                    key: false,
                    apm: false,
                    beep: false,
                    lcd: false,
                },
                inputs: [
                    {
                        port: '01',
                        name: 'HDMI1',
                    },
                    {
                        port: '02',
                        name: 'HDMI2',
                    },
                    {
                        port: '03',
                        name: 'HDMI3',
                    },
                    {
                        port: '04',
                        name: 'HDMI4',
                    },
                    {
                        port: '05',
                        name: 'VGA',
                    },
                    {
                        port: '06',
                        name: 'YPBPR',
                    },
                    {
                        port: '07',
                        name: 'AV',
                    },
                ],
                outputs: [
                    {
                        input: 'HDMI1',
                        port: '01',
                        name: 'HDMI1',
                        outputEnabled: true,
                        hdmiCon: true,
                        osp: 'SNK',
                    },
                    {
                        input: 'HDMI1',
                        port: '02',
                        name: 'HDMI1',
                        outputEnabled: true,
                        hdmiCon: true,
                        osp: 'SNK',
                    },
                ],
            },
            {
                createStatusMessage: this.mfp112CreateStatusMessage,
                modelNumber: '-M5g_yvYs8mauLxVU-fv',
                volume: 15,
                mute: false,
                model: 'MFP112',
                name: 'HDMI MFP112  Status',
                version: '2.11',
                status: {
                    power: false,
                    ir: false,
                    key: false,
                    apm: false,
                    beep: false,
                    lcd: false,
                },
                inputs: [
                    {
                        port: '01',
                        name: 'HDBT',
                    },
                    {
                        port: '02',
                        name: 'HDMI1',
                    },
                    {
                        port: '03',
                        name: 'HDMI2',
                    },
                    {
                        port: '04',
                        name: 'HDMI3',
                    },
                    {
                        port: '05',
                        name: 'HDMI4',
                    },
                    {
                        port: '06',
                        name: 'VGA1',
                    },
                    {
                        port: '07',
                        name: 'VGA2',
                    },
                    {
                        port: '08',
                        name: 'VGA3',
                    },
                    {
                        port: '09',
                        name: 'VGA4',
                    },
                    {
                        port: '10',
                        name: 'YPBPR',
                    },
                    {
                        port: '11',
                        name: 'AV',
                    },
                ],
                outputs: [
                    {
                        input: 'HDMI1',
                        port: '01',
                        name: 'HDMI1',
                        outputEnabled: true,
                        hdmiCon: true,
                        osp: 'SNK',
                    },
                    {
                        input: 'HDMI1',
                        port: '02',
                        name: 'HDMI1',
                        outputEnabled: true,
                        hdmiCon: true,
                        osp: 'SNK',
                    },
                ],
            },
        ];
        this.product = this.products[0];
    }
    onConfigure(config) {
        for (const product of this.products) {
            if (product.modelNumber === config.modelNumber) {
                this.product = product;
                return;
            }
        }
        this.log.error(`unexpected model number: ${config.modelNumber}`);
        this.product = this.products[0];
    }
    // Convert "HDMIn" -> "HDMI 0n" and "VGAn" -> "VGA0n".
    adjustInputName(value) {
        const match = /(HDMI|VGA)(\d+)/i.exec(value);
        if (match)
            return `${match[1]} ${match[2].padStart(2, '0')}`;
        return value;
    }
    c44KitCreateStatusMessage(product) {
        let outString = 'STATUS\r\n\r\n' +
            '================================================================\r\n\r\n' +
            `               ${product.name}\r\n` +
            `               FW Version:\r\n        ${product.version}\r\n` +
            `Power     IR    Key   Beep  Baud\r\n` +
            `${product.status.power ? 'ON' : 'OFF'}       ` +
            `${product.status.ir ? 'ON' : 'OFF'}    ` +
            `${product.status.key ? 'ON' : 'OFF'}  ` +
            'OFF   OFF  57000\r\n' +
            'Input   Edid       HDMIcon\r\n';
        for (const value of product.inputs) {
            outString += `${value.port}      FORCE___00    ON\r\n`;
        }
        outString += '\r\nOutput   FromIn  HDMI/HDBTcon   OutputEn   POH  OSP\r\n';
        for (const value of product.outputs) {
            outString += `${value.port}       ${value.input}           ${value.hdmiCon ? 'Yes' : 'No'}      ${value.outputEnabled ? 'Yes' : 'No'}   ON   SNK\r\n`;
        }
        outString +=
            'Telnet                 MAC\r\n' +
                '23                   34:D0:B8:20:2F:49\r\n' +
                '================================================================\r\n';
        return outString;
    }
    mfp62CreateStatusMessage(product) {
        let outString = 'STATUS\r\n\r\n' +
            '================================================================\r\n\r\n' +
            `               ${product.name}\r\n` +
            `               FW Version: ${product.version}\r\n` +
            `               Scaler Version: 1.20\r\n\r\n` +
            `Power     IR    Key    LCD\r\n` +
            `${product.status.power ? 'ON' : 'OFF'}        ` +
            `${product.status.ir ? 'ON' : 'OFF'}    ` +
            `${product.status.key ? 'ON' : 'OFF'}    ` +
            `${product.status.lcd ? 'ON' : 'OFF'}\r\n\r\n` +
            'Input   Edid         RXcon   AudioSource\r\n';
        for (const value of product.inputs) {
            outString += `${value.port}   Default_00   Off   Original\r\n`;
        }
        outString += '\r\nOutput   FromIn   HdmiCon   OutputEn   OSP\r\n';
        for (const value of product.outputs) {
            outString += `${value.port}      ${value.input}    ${value.hdmiCon ? 'On' : 'Off'}    ${value.outputEnabled ? 'Yes' : 'No'}   ${value.osp}\r\n`;
        }
        outString +=
            '\r\nSCA  Vol   Mute  Format  PCM   OSD  Freq   SetRes  OutRes\r\n' +
                `ORG  ${product.volume}  ${product.mute ? 'ON' : 'Off'}   PCM     SCA   ON   Auto   09      00\r\n` +
                'Telnet                 MAC\r\n' +
                '8000                   34:D0:B8:20:2F:49\r\n' +
                '================================================================\r\n';
        return outString;
    }
    mfp72CreateStatusMessage(product) {
        let outString = 'STATUS\r\n\r\n' +
            '================================================================\r\n\r\n' +
            `               ${product.name}\r\n` +
            `               FW Version: ${product.version}\r\n` +
            `               Scaler Version: 1.36\r\n\r\n` +
            `Power     IR    Key    DBG   Beep LCD\r\n` +
            `${product.status.power ? 'ON' : 'OFF'}       ` +
            `${product.status.ir ? 'ON' : 'OFF'}    ` +
            `${product.status.key ? 'ON' : 'OFF'}  ` +
            'OFF   OFF  ' +
            `${product.status.lcd ? 'ON' : 'OFF'}\r\n\r\n` +
            'Input   EdidIndex       CableConn\r\n';
        for (const value of product.inputs) {
            outString += `${value.port}      FORCE___00    Yes\r\n`;
        }
        outString += '\r\nOutput   SelectInput  CableConn   OutputEn   Mode\r\n';
        for (const value of product.outputs) {
            outString += `${value.port}       ${value.input}           ${value.hdmiCon ? 'Yes' : 'No'}      ${value.outputEnabled ? 'Yes' : 'No'}   MATRIX\r\n`;
        }
        outString +=
            '\r\nScalerAudio  Volume   Mute  Format  Resolution  Frequence\r\n' +
                `Orginal      ${product.volume}      ${product.mute ? 'ON' : 'OFF'}   PCM     1080P@60Hz AUTO\r\n` +
                'ScalerAspect   OSD   ZoomOut Overscan\r\n' +
                'FullScreen     OFF   No      No\r\n' +
                '================================================================\r\n';
        return outString;
    }
    mfp112CreateStatusMessage(product) {
        let outString = 'STATUS\r\n\r\n' +
            '================================================================\r\n\r\n' +
            `               ${product.name}\r\n` +
            `               FW Version: ${product.version}\r\n` +
            `               Scaler Version: 1.36\r\n\r\n` +
            `Power     IR    Key    DBG   Beep LCD\r\n` +
            `${product.status.power ? 'ON' : 'OFF'}       ` +
            `${product.status.ir ? 'ON' : 'OFF'}    ` +
            `${product.status.key ? 'ON' : 'OFF'}  ` +
            'OFF   OFF  ' +
            `${product.status.lcd ? 'ON' : 'OFF'}\r\n\r\n` +
            'Input   EdidIndex       CableConn    Audio\r\n';
        for (const value of product.inputs) {
            outString += `${value.name}      FORCE___00       No        Original\r\n`;
        }
        outString += '\r\nOutput   SelectInput  CableConn   OutputEn   Mode\r\n';
        for (const value of product.outputs) {
            outString += `${value.port}        ${value.input}      ${value.hdmiCon ? 'Yes' : 'No'}      ${value.outputEnabled ? 'Yes' : 'No'}   MATRIX\r\n`;
        }
        outString +=
            '\r\nScalerAudio  Volume  Format  Bypass  Resolution  Frequence\r\n' +
                `Orginal      ${product.volume}         PCM    OFF  1080P@60Hz AUTO\r\n` +
                'ScalerAspect   OSD   ZoomOut Overscan\r\n' +
                'KeepAR     OFF   No      No\r\n' +
                '================================================================\r\n';
        return outString;
    }
}
Blustream.emulatorType = 'socketEmulator';
Blustream.key = '-M5g_hap5PUG_lHcCUoF';
